import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { LprQueryResultsModel } from './lpr-query.model';

export class LprReadsModel extends SnModel {
  @Expose()
  @Type(() => LprQueryResultsModel)
  public items: LprQueryResultsModel[];

  @Expose()
  public total: number;

  @Expose()
  public page: number;

  @Expose()
  public size: number;

  @Expose()
  public pages: number;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
